'use client';

import { useABSmartlyExperiments } from '@ria-client/absmartly/hooks/useABSmartlyExperiments';
import { useABSmartlyContext } from '@ria-client/absmartly/provider/ABSmartlyProvider';
import type { ReactNode } from 'react';

// Renders nothing until ABsmartly is ready, and for every variant the visitor is not in.
export function ExperimentGate({
  testName,
  variant,
  children,
}: {
  testName: string;
  variant: string;
  children: ReactNode;
}) {
  const context = useABSmartlyContext();
  const {
    isReady,
    results: [active],
  } = useABSmartlyExperiments(testName);
  const hasExperiment =
    isReady && context?.data().experiments?.some(experiment => experiment.name === testName);

  return isReady && hasExperiment && active === variant ? children : null;
}
